import * as React from 'react'
import { observer } from 'mobx-react'
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap'

import { Link } from 'react-router'
import { Routes } from '../../../../../constants/Routes'
import { INestedProduct, productName } from '@getgreenline/homi-shared'

interface Props {
  onHide: () => void
  onOverrideInvoiceLine: () => void
  companyId: number
  product: INestedProduct
}

@observer
export class EditCompletedCostModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
  }

  render() {
    const { product, companyId } = this.props
    const productId = product.parentProductId || product.id
    const convertedProductName = productName(product)
    return (
      <Modal isOpen={true} toggle={() => this.props.onHide()} autoFocus={false}>
        <ModalHeader>Edit a completed cost</ModalHeader>
        <ModalBody className='text-xs-center'>
          <p>Your store is set to use weighted average costs.</p>
          <p>
            If you edit your costs now, your product cost will be only updated on this invoice and
            the changes will not reflect on your actual product and inventory. If you want to change
            your product's wholesale cost, go to the{' '}
            <Link to={Routes.EDIT_PRODUCT(companyId, productId)}>{convertedProductName}</Link> page
            to update the price.{' '}
          </p>
          <br />
          <Button
            className='btn btn-lg btn-light w-100'
            onClick={() => this.props.onOverrideInvoiceLine()}
          >
            I understand
          </Button>
        </ModalBody>
      </Modal>
    )
  }
}
